import { pbaPlugin } from '../plugins/pbaPlugin';
import { navigationPlugin } from '../plugins/navigationPlugin/navigationPlugin';
import { helpPlugin } from '../plugins/helpPlugin/helpPlugin';
import { projectPlugin } from '../plugins/projectPlugin/projectPlugin';

/**
 * @typedef {Object} CommandPaletteGroupTranslationName
 * @property {'translation'} type
 * @property {string} key
 */
/**
 * @typedef {Object} CommandPaletteGroupValueName
 * @property {'value'} type
 * @property {string} value
 */
/**
 * @typedef {Object} CommandPaletteGroup
 * @property {CommandPaletteGroupTranslationName | CommandPaletteGroupValueName} groupName
 * @property {import('./plugins').CommandPalettePlugin[]} plugins
 * @property {string} groupId
 */
/**
 * @typedef {Object} CommandPalettePane
 * @property {string} paneId
 * @property {CommandPaletteGroup[]} groups
 */

/** @type {CommandPalettePane[]} */
export const panes = [
  {
    paneId: 'default',
    groups: [
      {
        groupName: { type: 'value', value: 'Navigation' },
        plugins: [navigationPlugin],
        groupId: 'navigation',
      },
      {
        groupName: { type: 'value', value: 'Switch To' },
        plugins: [pbaPlugin],
        groupId: 'pbas',
      },
      {
        groupName: { type: 'value', value: 'Projects' },
        plugins: [projectPlugin],
        groupId: 'projects',
      },
      {
        groupName: { type: 'value', value: 'Help' },
        plugins: [helpPlugin],
        groupId: 'help',
      },
    ],
  },
];
